import React, { Component } from 'react';
import './style.css';
import { Trans, translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faArrowUp } from '@fortawesome/free-solid-svg-icons';

class Opposite extends Component {
  constructor(props) {
    super(props);
    let opposite = props.pair.answer.opposite || '';
    this.state = {
      value: opposite,
      suggestedTerms: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.fetchSuggestedTerms = this.fetchSuggestedTerms.bind(this);
  }

  componentDidMount() {
    this.fetchSuggestedTerms();
  }

  handleChange(event) {
    this.setState({
      value: event.target.value
    });
  }

  fetchSuggestedTerms() {
    const {
      term,
      i18n: { language: lang }
    } = this.props;
    console.log(lang);

    const payload = {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        term,
        engine: 'datamuse',
        lang
      })
    };

    fetch(
      process.env.REACT_APP_API_URL + '/backend/interview/api/opposite-term/',
      payload
    )
      .then(response => response.json())
      .then(json => this.setState({ suggestedTerms: json.result }))
      .catch(err => console.log('Error while fetching opposite term:', err));
  }

  render() {
    const { t } = this.props;
    const term = this.props.term;
    const description = (
      <Trans i18nKey="oppositeNew">
        The opposite of <b>"{{ term }}"</b> in this context is...
      </Trans>
    );

    let skip = () => {
      const nextPath = this.props.skip(this.props.pair);
      if (this.props.history.canGo(1)) {
        this.props.history.goForward();
      } else {
        this.props.history.push(nextPath);
      }
    };

    let suggestedTermsContainer;
    if (this.state.suggestedTerms.length > 0) {
      suggestedTermsContainer = (
        <div>
          <small className="d-block mt-4 mb-3 text-muted">
            Suggested opposites:
          </small>
          <div className="suggested-options">
            {this.state.suggestedTerms.map(term => (
              <button
                className="btn-suggested-option"
                onClick={() => this.setState({ value: term })}
              >
                {term}
                <FontAwesomeIcon className="arrow-up-left" icon={faArrowUp} />
              </button>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div className="card-body">
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="question">{description}</div>
        <div className="text-input-container">
          <input
            autoFocus
            type="text"
            className="text-input"
            placeholder={t('Opposite...')}
            onChange={this.handleChange}
            value={this.state.value}
            maxLength={this.props.maxLength}
          />
          {suggestedTermsContainer}
        </div>
        <div className="actions">
          <button className="btn btn-link" onClick={skip}>
            Skip Question
          </button>
          <Link to={this.props.url + '/confirm'}>
            <button
              className="btn btn-primary btn-round btn-next"
              onClick={() => this.props.save(this.state.value)}
              disabled={!this.state.value}
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default translate('translations')(withRouter(Opposite));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Pair/opposite.js